
export const ZIP_URL = "{.mediaBaseUrl}/transform/zip?cs={.callerStack}";

export const enum ALL {
    // Common properties
    accessToken = '.accessToken',
    callerStack = '.callerStack',
    correlationId = '.correlationId',
    mediaBaseUrl = '.mediaBaseUrl',
    mediaBaseUrlSecondary = '.mediaBaseUrlSecondary',
    pushChannelBaseUrl = '.pushChannelBaseUrl',
    driveAccessToken = '.driveAccessToken',
    driveAccessTokenV21 = '.driveAccessTokenV21',
    driveUrl = '.driveUrl',
    driveUrlV21 = '.driveUrlV21',
    pdfConversionUrl = '.pdfConversionUrl',
    thumbnailUrl = '.thumbnailUrl',
    transformUrl = '.transformUrl',
    videoManifestUrl = '.videoManifestUrl',
    zipUrl = '.zipUrl',
    officeBundleGenerate = '.officeBundleGenerate',
    officeBundleGetFragment = '.officeBundleGetFragment',

    // Item properties
    resourceUrl = '.spResourceUrl',

    // List item properties
    fileType = '.fileType',
    itemUrl = '.spItemUrl',
    cTag = '.ctag',
    hasBxf = '.hasBxf',
    hasOfficePreview = '.hasOfficePreview',
    hasPdf = '.hasPdf',
    hasThumbnail = '.hasThumbnail',
    hasVideoManifest = '.hasVideoManifest',

    // Special properties
    analyzeUrl = '.analyzeUrl'
}

// Properties that are shared across a list of items
export const COMMON = [
    ALL.accessToken,
    ALL.callerStack,
    ALL.mediaBaseUrl,
    ALL.mediaBaseUrlSecondary,
    ALL.pushChannelBaseUrl,
    ALL.driveAccessToken,
    ALL.driveUrl,
    ALL.driveAccessTokenV21,
    ALL.driveUrlV21,
    ALL.zipUrl,
    ALL.pdfConversionUrl,
    ALL.thumbnailUrl,
    ALL.transformUrl,
    ALL.videoManifestUrl,
    ALL.officeBundleGenerate,
    ALL.officeBundleGetFragment
];

export const FALLBACK_PROPERTIES = [
    ALL.callerStack,
    ALL.correlationId,
    ALL.mediaBaseUrl,
    ALL.resourceUrl
];

export type MicroServicePropertiesValueType = {
    [p in ALL]?: string;
};
